import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { afterItems, beforeItems } from '../data/site';
import { SectionCta } from './SectionCta';
export function BeforeAfter() {
  return <section className="w-full bg-sand px-5 py-14 sm:px-6 sm:py-20" data-id="element-40" data-mp="3og1bikikbq82">
      <div className="mx-auto max-w-4xl" data-id="element-41" data-mp="3oi42p7vgbped">
        <h2 className="text-center font-serif text-[28px] font-bold leading-[1.12] text-navy sm:text-4xl" data-id="element-42" data-mp="3sgl9trevgzvs">
          Find the pathway. Follow the structure.
          <br className="hidden sm:block" data-id="element-43" data-mp="3eo542iul6nr6" /> Make the next decision.
        </h2>

        <div className="mt-9 grid gap-5 md:grid-cols-2 md:gap-6" data-id="element-44" data-mp="3jhzm7hujmuo5">
          {/* BEFORE — all items grouped on one side */}
          <div className="rounded-2xl border border-navy/10 bg-white/70 p-5 sm:p-6" data-id="element-45" data-mp="39qv5odp7z1r7">
            <p className="text-[11px] font-bold uppercase tracking-[0.14em] text-navy/50" data-id="element-46" data-mp="39osjy5v3nusa">Before</p>
            <h3 className="mt-1.5 font-serif text-xl font-bold text-navy sm:text-2xl" data-id="element-47" data-mp="2vt6trvd4r4ya">
              Without the Decision Desk™
            </h3>
            <ul className="mt-5 space-y-3" data-id="element-48" data-mp="x3sh4f0d9aso">
              {beforeItems.map(item => <li key={item} className="flex items-start gap-3" data-id="element-49" data-mp="t3i3cg6c1g39">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-rose-100" data-id="element-50" data-mp="t5b8fr1ars95">
                    <XIcon className="h-3 w-3 text-rose-700" aria-hidden="true" data-id="element-51" data-mp="123wptiv1918c" />
                  </span>
                  <span className="text-[14.5px] leading-snug text-navy/70" data-id="element-52" data-mp="edj5keiow6ob">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* AFTER — all items grouped on the other side */}
          <div className="rounded-2xl border-2 border-gold bg-navy p-5 sm:p-6" data-id="element-53" data-mp="o4xbp555c4qf">
            <p className="text-[11px] font-bold uppercase tracking-[0.14em] text-gold-light" data-id="element-54" data-mp="jcncszm1zuc0">After</p>
            <h3 className="mt-1.5 font-serif text-xl font-bold text-cream sm:text-2xl" data-id="element-55" data-mp="3rsfenebtdvwg">
              With the Decision Desk™
            </h3>
            <ul className="mt-5 space-y-3" data-id="element-56" data-mp="3mtm1xo4cq8xc">
              {afterItems.map(item => <li key={item} className="flex items-start gap-3" data-id="element-57" data-mp="1qq7xdlhapfz1">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-gold-light" data-id="element-58" data-mp="1vp0zkhr4tkjw">
                    <CheckIcon className="h-3 w-3 text-ink" aria-hidden="true" data-id="element-59" data-mp="20hu4p6qiiuwi" />
                  </span>
                  <span className="text-[14.5px] font-medium leading-snug text-cream/90" data-id="element-60" data-mp="24gun4o52vviz">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <SectionCta headline="Move from scattered information to one organized clinical desk." label="Get instant access · $27" data-id="element-61" data-mp="1crzt0shxjcdu" />
      </div>
    </section>;
}